import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { toast } from 'react-toastify';

const Communities = () => {
  const [isLoading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const sendEmail = async () => {
    setLoading(true);
    try {
      await axios.post(
        'https://api.softsmartinc.com/Services/vNew/Widget/Email/Send',
        {
          Attachments: [],
          Body: `<p>${formData.message}<br/><br/>Regards<br/>${formData.name}<br/>${formData.email}</p>`,
          Email: 'info@softsmartcorp.com',
          EmailTo: 'service@abmpropertymgmt.com',
          Subject: `You Have a New Inquiry from Your Website`
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer 14FE34B2-9547-43F5-A57C-F0DC7DE81AA9'
          }
        }
      );
      setFormData({
        name: "",
        email: "",
        message: ""
      });
      toast.success("Email sent successfully!");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.success('Error sending email:', error.response?.data || error.message);
    }
  };


  return (
    <div className="connect-us" id="contact-us">
      <div className="img-box"></div>
      <div className="connect-us-section">
        <div className="connect-us-section-title">BUILDING STRONG COMMUNITIES</div>
        <div className="connect-us-section-sub-title">ABM Property Management, Inc.</div>
        <p className="address">
          1919 Williams St., Unit 360<br />
          Simi Valley, CA 93065<br />
          (805) 522-0292 Office<br />
          (805) 813-8138 Fax
        </p>
        <div className="connect-us-section-title mb-3">CONTACT FORM</div>
        <form className="contact-form" action="https://formsubmit.co/abm@yopmail.com"
          method="POST">
          <div className='row'>
            <div className='col-md-6'>
              <input type="text" placeholder="Your Name" value={formData.name} name='name' onChange={handleChange} className="input-box" />
            </div>
            <div className='col-md-6'>
              <input type="email" placeholder="Your Email" value={formData.email} name='email' onChange={handleChange} className="input-box" />
            </div>
            <div className='col-md-12 mt-4'>
              <textarea placeholder="Type your message" value={formData.message} name='message' onChange={handleChange} className="textarea-box"></textarea>
            </div>
          </div>
          <button type="button" disabled={isLoading || !formData.name || !formData.email || !formData.message} className="submit-btn" onClick={sendEmail}>
            <div className='d-flex align-items-center gap-2'>
              {isLoading && <div className='loader'></div> }
              SUBMIT MESSAGE
            </div>
          </button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}
export default Communities;